export default __webpack_public_path__ + "static/media/fatality.aefc77ba.png";